import React from "react";
import PropTypes from "prop-types";
import { Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const navBarItem = props => {
  const { img, label, selected, onClick, action, warning, empty, unpublished, basechanged, icon } = props;
  return (
    <div className={`navBar-item ${selected && "current"} ${action && "action"}`}>
      {img && <img alt={label} src={img} />}
      {icon && (
        <span style={{ fontSize: "0.5em" }}>
          <FontAwesomeIcon icon={icon} />
        </span>
      )}
      <span className="label">
        <Button
          color="link"
          onClick={() => {
            onClick(label);
          }}
          style={{
            textAlign: "left",
            width: "150px",
            color: "inherit",
            textDecoration: "inherit",
            whiteSpace: "normal"
          }}
        >
          {label && label.replace("-", `\u{2011}`)}
        </Button>
      </span>
      {warning && warning > 0 ? (
        <div title="Warning" className="badge warning">
          {warning}
        </div>
      ) : (
        ""
      )}
      {empty && empty > 0 ? (
        <div title="Empty" className="badge empty">
          {empty}
        </div>
      ) : (
        ""
      )}
      {unpublished && unpublished > 0 ? (
        <div title="Not Published Changes" className="badge unpublished">
          {unpublished}
        </div>
      ) : (
        ""
      )}
      {basechanged && basechanged > 0 ? (
        <div title="Base Text Changed" className="badge basechanged">
          {basechanged}
        </div>
      ) : (
        ""
      )}
      {selected ? <div className="triangle" /> : ""}
    </div>
  );
};

export default navBarItem;

navBarItem.defaultProps = {
  selected: false,
  img: "",
  onClick: () => {}
};

navBarItem.propTypes = {
  label: PropTypes.string.isRequired,
  img: PropTypes.string,
  selected: PropTypes.bool,
  onClick: PropTypes.func
};
